import { render } from "./DropdownStockCategories.vue?vue&type=template&id=268c7b83"
import script from "./DropdownStockCategories.vue?vue&type=script&lang=ts"
export * from "./DropdownStockCategories.vue?vue&type=script&lang=ts"
script.render = render

export default script